import { yaNative } from '@weberus/ui/utils/ya-native';

import type { SwipeBackParam } from '@yanolja-rnd/ya-native/interfaces';

/**
 * 화면 위에 놓이는 레이아웃 요소인 FullScreenModal, Popup, BottomSheet에서
 * IOS SwipeBack 지원 여부를 결정하기 위해 처리하기 위해 사용되는 옵션
 *
 * @link {https://yanolja.atlassian.net/wiki/spaces/FEDEV/pages/121274385} 개발문서
 * @link {https://yanolja.atlassian.net/wiki/spaces/platformdiv/pages/90613391} AC 문서
 */
export interface SwipeBackOption {
  onOpen: () => void;
  onClose: () => void;
}

const DEFAULT_SWIPE_BACK: SwipeBackParam = { mode: 'close' };

/**
 * FullScreenModal 화면에서 사용되는 swipeBack 옵션
 */
export const MODAL__SWIPE_BACK__OPTION: SwipeBackOption = {
  onOpen: () => {
    yaNative.isEnabled && yaNative.setSwipeBack({ mode: 'fixed' }); // swipeBack 막기
  },
  onClose: () => {
    yaNative.isEnabled && yaNative.setSwipeBack(DEFAULT_SWIPE_BACK); // swipeBack 허용 (웹뷰 닫기)
  },
};

/**
 * Popup, BottomSheet 화면에서 사용되는 SwipeBack 옵션
 */
export const POPUP_BOTTOM_SHEET__SWIPE_BACK__OPTION: SwipeBackOption = {
  onOpen: () => {
    yaNative.isEnabled && yaNative.setSwipeBack(DEFAULT_SWIPE_BACK); // swipeBack 허용 (웹뷰 닫기)
  },
  onClose: () => {
    yaNative.isEnabled && yaNative.setSwipeBack(DEFAULT_SWIPE_BACK); // swipeBack 허용 (웹뷰 닫기)
  },
};
